import {
  Commands,
  Internal,
  RootStore,
  StateWithPropertyChanges,
  User,
  UserStore,
} from '@jobnimbus/web-state';

import { CONTAINER_ID } from '../engage-constants';
import { setInitialProfile } from './resize-handlers';

export function sendMessageToEmbeddedApp(
  propertyChanges: StateWithPropertyChanges<any>,
  embeddedAppOrigin: string,
  verbose: boolean
) {
  if (!propertyChanges) return;

  const { engageActiveCommand, debugEnabled, isLoggedIn } =
    propertyChanges.stateChanges;

  SendMessage(
    {
      COMMAND_REQUEST: engageActiveCommand || undefined,
      DEBUG_STATUS: debugEnabled,
      USER_PROPERTY_CHANGED:
        isLoggedIn !== undefined ? { isLoggedIn } : undefined,
    },
    embeddedAppOrigin,
    verbose
  );
}

//#region Print
function setPrint(event) {
  this.contentWindow.focus(); // Required for IE
  this.contentWindow.print();
  self.close();
}

export function printExternalPage(url) {
  const oldPrintFrame = document.getElementById('externalPrintIframe');
  if (oldPrintFrame) {
    oldPrintFrame.remove();
  }
  const externalPrintIframe = document.createElement('iframe');
  externalPrintIframe.setAttribute('id', 'externalPrintIframe');
  externalPrintIframe.addEventListener('load', setPrint);
  externalPrintIframe.style.position = 'fixed';
  externalPrintIframe.style.right = '0';
  externalPrintIframe.style.bottom = '0';
  externalPrintIframe.style.width = '0';
  externalPrintIframe.style.height = '0';
  externalPrintIframe.style.border = '0';

  externalPrintIframe.src = url;
  document.body.appendChild(externalPrintIframe);
}
//#endregion

export const SendMessage = (
  message: object,
  embeddedAppOrigin: string,
  verbose: boolean
) => {
  if (verbose) console.log(`Sending message to ${embeddedAppOrigin}:`, message);

  const embeddedAppFrame = (
    document.getElementById(CONTAINER_ID) as HTMLIFrameElement
  )?.contentWindow;

  if (embeddedAppFrame)
    embeddedAppFrame.postMessage(message, embeddedAppOrigin);
};

export const SendMessageToSelf = (message: object, verbose: boolean) => {
  if (verbose)
    console.log(`Sending message to ${window.location.origin}:`, message);

  window.postMessage(message, window.location.origin);
};

export const handleUserStoreChange = (
  propertyChanges: StateWithPropertyChanges<User>,
  embeddedAppOrigin: string,
  debugEnabled: boolean,
  userStore: UserStore
) => {
  if (!propertyChanges?.stateChanges) {
    return;
  }

  const { isLoggedIn, ldFlagSet } = propertyChanges.stateChanges;

  const accessToken = userStore.accessToken;
  if (accessToken) {
    SendMessage({ ACCESS_TOKEN: accessToken }, embeddedAppOrigin, debugEnabled);
  }

  if (isLoggedIn !== undefined) {
    setInitialProfile(isLoggedIn);
    sendMessageToEmbeddedApp(propertyChanges, embeddedAppOrigin, debugEnabled);
  }

  if (ldFlagSet !== undefined) {
    SendMessage({ FEATURE_FLAGS: ldFlagSet || {} }, embeddedAppOrigin, debugEnabled);
  }
};

export function subscribeToStoreChanges({
  rootStore,
  engageOrigin,
}: {
  rootStore: RootStore;
  engageOrigin: string;
}) {
  return [
    rootStore.commandStore.stateWithPropertyChanges.subscribe(
      (propertyChanges: StateWithPropertyChanges<Commands>) => {
        sendMessageToEmbeddedApp(
          propertyChanges,
          engageOrigin,
          rootStore.internalStore.debugEnabled
        );
      }
    ),
    rootStore.internalStore.stateWithPropertyChanges.subscribe(
      (propertyChanges: StateWithPropertyChanges<Internal>) => {
        sendMessageToEmbeddedApp(
          propertyChanges,
          engageOrigin,
          rootStore.internalStore.debugEnabled
        );
      }
    ),
    rootStore.userStore.stateWithPropertyChanges.subscribe((propertyChanges) =>
      handleUserStoreChange(
        propertyChanges,
        engageOrigin,
        rootStore.internalStore.debugEnabled,
        rootStore.userStore
      )
    ),
  ];
}
